import Vue from "vue";
import VueRouter from "vue-router";
import fun from "@/utlis/CommonlyUsedFunctions.js";
import store from "../store/index.js";
import apis from "../api/apis";
import fanyi from "../utlis/language";
import { applyPageHead } from "../utlis/pageHead";
import {
  getShopGroupCategoryPageSeo,
  productDetailsPageSeo,
} from "../utlis/pageSeoMap";
import centroDeAyuda from "../views/footList/FAQ/unitl/routePathList";
// 根据 getShopGroup 数据动态生成分类路由
import {
  getShopGroupCatchAllRoute,
  ensureShopGroupCategories,
  getShopGroupRouteRedirect,
} from "../utlis/shopGroupRoute";

import { Message, MessageBox } from "element-ui";

// 帮助中心首页 SEO（与 routePathList 同步）
const centroDeAyudaMainSeo = centroDeAyuda.find(
  (item) => item && item.router === "centro-de-ayuda"
);
Vue.use(VueRouter);

const routes = [
  /* 用户页面*/
  {
    path: "/user",
    name: "user",
    component: () => import("../views/UserCenter/index.vue"),
    meta: {
      requireAuth: true,
    },
    children: [
      // 用户-首页
      {
        path: "/user/index",
        name: "userIndex",
        component: () =>
          import("../views/UserCenter/views/UserIndex/index.vue"),
        meta: {},
      },
      // 用户-订单页面
      {
        path: "/user/order",
        name: "userOrder",
        component: () =>
          import("../views/UserCenter/views/userOrder/index.vue"),
        meta: {},
      },

      // 用户-问题产品
      {
        path: "/user/issueOrder",
        name: "issueOrder",
        component: () =>
          import("../views/UserCenter/views/issueOrder/index.vue"),
        meta: {},
      },

      // 用户-运输中页面
      {
        path: "/user/wuliuStatus",
        name: "wuliuStatus",

        component: () =>
          import("../views/UserCenter/views/wuliuStatus/index.vue"),
        meta: {},
      },
      // 用户-仓库页面
      {
        path: "/user/warehouse",
        name: "warehouse",
        component: () =>
          import("../views/UserCenter/views/warehouse/index.vue"),
        meta: {},
      },

      // 用户-收藏夹产品页面
      {
        path: "/user/collection",
        name: "collection",
        component: () =>
          import("../views/UserCenter/views/collection/index.vue"),
        meta: {},
      },
      // 用户-收藏夹商店页面
      {
        path: "/user/favoritec",
        name: "favoritec",

        component: () =>
          import("../views/UserCenter/views/favoritec/index.vue"),
        meta: {},
      },
      //用户-发票历史
      {
        path: "/user/invoiceHistory",
        name: "invoiceHistory",
        component: () =>
          import("../views/UserCenter/views/invoiceHistory/index.vue"),
        meta: {},
      },
      //用户-发票账单数据
      {
        path: "/user/invoiceBillingData",
        name: "invoiceBillingData",
        component: () =>
          import("../views/UserCenter/views/invoiceBillingData/index.vue"),
        meta: {},
      },
      // 用户-收藏夹商品库列表页面
      {
        path: "/user/commodity",
        name: "commodity",
        component: () =>
          import("../views/UserCenter/views/commodity/index.vue"),
        meta: {},
      },
      // 用户-登录信息页面
      {
        path: "/user/userDetail",
        name: "userDetail",
        component: () =>
          import("../views/UserCenter/views/userDetail/index.vue"),
        meta: {},
      },
      // 用户-编辑地址页面
      {
        path: "/user/deliverySite",
        name: "deliverySite",

        component: () =>
          import("../views/UserCenter/views/deliverySite/index.vue"),
        meta: {},
      },

      // 用户-更改密码页面
      {
        path: "/user/changepassworld",
        name: "changepassworld",
        component: () =>
          import("../views/UserCenter/views/changepassworld/index.vue"),
        meta: {},
      },
      // 用户-优惠券
      {
        path: "/user/coupon",
        name: "coupon",
        component: () => import("../views/UserCenter/views/coupon/index.vue"),
        meta: {},
      },
      // 用户-国际物流
      {
        path: "/user/internationalLogistics",
        name: "internationalLogistics",
        component: () =>
          import("../views/UserCenter/views/Prezzo-della-logística/idnex.vue"),
        meta: {},
      },
      // 用户-通知
      {
        path: "/user/inform",
        name: "inform",

        component: () => import("../views/UserCenter/views/inform/idnex.vue"),
        meta: {},
      },
    ],
  },
  // 首页
  {
    path: "/",
    name: "homepage",
    meta: {
      tagTitle: "Soluzioni complete dal produttore cinese al tuo magazzino",
      tagDescription:
        "Importi dalla Cina in modo semplice e sicuro. Rakumart offre soluzioni complete di approvvigionamento e logistica dal produttore al tuo magazzino. Richiedi un preventivo!",
      buDaiRakumart: true,
    },
    component: () => import("../views/homepage/index.vue"),
  },

  // cookie政策页面（写死静态路由）
  {
    path: "/Informativa-sui-cookie",
    alias: "/politica-de-cookies",
    name: "Informativa-sui-cookie",
    meta: {
      tagTitle: "Informativa sui cookie - Rakumart Italia",
      tagDescription:
        "Consulta l'Informativa sui cookie di Rakumart Italia per sapere come utilizziamo i cookie e come gestire le tue preferenze di navigazione.",
      buDaiRakumart: true,
    },
    component: () => import("../views/footList/Informativa-sui-cookie.vue"),
  },
  // 隐私政策页面（写死静态路由）
  {
    path: "/Informativa-sulla-privacy",
    alias: "/politica-privacidad",
    name: "Informativa-sulla-privacy",
    meta: {
      tagTitle: "Informativa sulla privacy - Rakumart Italia",
      tagDescription:
        "Consulta l'Informativa sulla privacy di Rakumart Italia per scoprire come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali.",
      buDaiRakumart: true,
    },
    component: () => import("../views/footList/Informativa-sulla-privacy.vue"),
  },
  // 合同页面（写死静态路由）
  {
    path: "/Condizioni-generali",
    alias: "/condiciones-generales-de-contratacion",
    name: "Condizioni-generali",
    meta: {
      tagTitle: "Termini e Condizioni di Servizio - Rakumart",
      tagDescription:
        "Leggi i termini e le condizioni di Rakumart per il nostro servizio di importazione dalla Cina. Scopri come garantiamo la tua spedizione.",
      buDaiRakumart: true,
    },
    component: () => import("../views/footList/Condizioni-generali.vue"),
  },
  // 法律条款（写死静态路由）
  {
    path: "/Note-legali",
    alias: "/aviso-legal",
    name: "Note-legali",
    meta: {
      tagTitle: "Note legali - Rakumart Italia",
      tagDescription:
        "Consulta la pagina Note legali di Rakumart Italia per conoscere termini di utilizzo, disclaimer e informazioni legali del sito.",
      buDaiRakumart: true,
    },
    component: () => import("../views/footList/Note-legali.vue"),
  },
  // 用户-问题产品详情
  {
    path: "/issueOrderDetail",
    name: "issueOrderDetail",

    component: () =>
      import("../views/UserCenter/views/issueOrder/views/issueOrderDetail.vue"),
    meta: {
      requireAuth: true,
    },
  },

  // 订单页面
  {
    path: "/OrderDetails",
    name: "OrderDetails",
    component: () =>
      import("../views/UserCenter/views/userOrder/views/OrderDetails.vue"),
    meta: {
      requireAuth: true,
    },
  },
  // 新商品详情
  {
    path: "/ProductDetails",
    name: "ProductDetails",
    meta: {
      ...productDetailsPageSeo,
      buDaiRakumart: true,
    },
    component: () => import("../views/newProductDetail/index.vue"),
  },
  // // 旧商品详情
  // {
  //     path: '/oProductDetails',
  //     name: 'oProductDetails',
  //     meta: {
  //         tagDescription: 'Junsheng mochila al aire libre bolsa de ventilador militar mochila de viaje X7 pez espada bolsa táctica montañismo bolsa de camuflaje 40 litros'
  //     },
  //     component: () => import('../views/order/ProductDetails.vue')
  // },
  // 店铺商品
  {
    path: "/shopGoods",
    name: "shopGoods",
    meta: {
      keepAlive: true,
    },
    component: () => import("../views/productDetail/shopGoods.vue"),
  },
  // 忘记密码页面（写死静态路由）
  {
    path: "/Reimposta-password",
    alias: "/ForgetThePassword",
    name: "Reimposta-password",
    meta: {
      tagTitle: "Recupera Password - Rakumart Italia",
      tagDescription:
        "Hai dimenticato la password su Rakumart? Inserisci la tua email per reimpostarla e continuare a importare dalla Cina facilmente.",
      buDaiRakumart: true,
    },
    component: () => import("../views/login/Reimposta-password.vue"),
  },

  /* 注册页面*/
  {
    path: "/Registrati",
    name: "register",
    meta: {
      tagTitle: "Crea un account Rakumart",
      tagDescription:
        "Importa dalla Cina in modo facile e sicuro. Registrati ora per accedere a milioni di prodotti cinesi e ottimizzare il tuo business.",
      buDaiRakumart: true,
    },
    component: () => import("../views/Registrati/index.vue"),
  },

  /* 注册成功*/
  {
    path: "/register-success",
    name: "register-success",
    component: () => import("../views/Registrati/index.vue"),
  },

  /* 个人信息补全*/
  {
    path: "/completePersonalInfo",
    name: "completePersonalInfo",
    meta: {
      requireAuth: true,
    },
    component: () => import("../views/completePersonalInfo/index.vue"),
  },

  /* 登录页面*/
  {
    path: "/login",
    name: "login",
    meta: {},
    component: () => import("../views/login/login.vue"),
  },
  /* 购物车列表*/
  {
    path: "/Carrello",
    name: "cart",
    component: () => import("../views/order/Carrello"),
    meta: {
      requireAuth: true,
      tagTitle: "Carrello - Rakumart.it",
      tagDescription:
        "Visualizza i prodotti che hai aggiunto al carrello Rakumart. Procedi in modo semplice e sicuro con il tuo ordine dalla Cina.",
      buDaiRakumart: true,
    },
  },
  /* 订单支付*/
  {
    path: "/payment",
    name: "payment",
    component: () => import("../views/payment/payment"),
    meta: {
      requireAuth: true,
    },
  },
  // /* 商品搜索页*/
  // {
  //   path: "/CommoditySearch",
  //   name: "CommoditySearch",
  //   component: () => import("../views/order/CommoditySearch"),
  // },

  /* 商品搜索页*/
  {
    path: "/CommoditySearch",
    name: "CommoditySearch",
    component: () => import("../views/CommoditySearch/index.vue"),
    meta: {
      keepAlive: true,
      buDaiRakumart: true,
    },
  },

  /* 物流与运输*/
  {
    path: "/Logistica-e-spedizioni",
    name: "logistica",
    component: () =>
      import(
        /* webpackChunkName: "foot" */ "../views/footList/Logistica-e-spedizioni"
      ),
    meta: {
      tagTitle: "Spedizioni Internazionali dalla Cina",
      tagDescription:
        "Soluzioni logistiche professionali dalla Cina all'Italia. Spedizioni veloci, sicure e trasparenti con Rakumart. Scopri i nostri servizi oggi!",
      buDaiRakumart: true,
    },
  },
  /* option*/
  {
    path: "/Costi-dei-servizi-extra",
    name: "option",

    component: () =>
      import(
        /* webpackChunkName: "foot" */ "../views/footList/Costi-dei-servizi-extra"
      ),
    meta: {
      tagTitle: "Servizi di valore aggiunto Rakumart",
      tagDescription:
        "Ottimizza i tuoi ordini dalla Cina: controllo qualità, imballaggio personalizzato e altri servizi logistici professionali. Scopri le soluzioni.",
      buDaiRakumart: true,
    },
  },
  /* 会员等级*/
  {
    path: "/Livello-utente",
    name: "comisiones-rakumart",
    meta: {
      tagTitle: "Commissioni e Livelli Utente Rakumart",
      tagDescription:
        "Scopri i costi trasparenti e le commissioni di Rakumart. Approfitta dei nostri servizi professionali di importazione senza costi nascosti.",
      buDaiRakumart: true,
    },
    component: () =>
      import(/* webpackChunkName: "foot" */ "../views/footList/Livello-utente"),
  },
  /* 公司推荐*/
  {
    path: "/Chi-siamo",
    name: "quienes-somos",
    meta: {
      tagTitle:
        "Rakumart: la migliore piattaforma B2B per l’approvvigionamento dalla Cina e la logistica internazionale",
      buDaiRakumart: true,
    },
    component: () =>
      import(/* webpackChunkName: "foot" */ "../views/footList/Chi-siamo"),
  },
  /*配送单详情*/
  {
    path: "/deliveryDetails",
    name: "deliveryDetails",
    component: () =>
      import(
        "../views/UserCenter/views/deliveryList/views/DeliveryDetails/index.vue"
      ),
    meta: {
      requireAuth: true,
    },
  },

  // 用户指南
  {
    path: "/guiaUsuario",
    name: "userGuide",
    meta: {
      tagTitle: "Guida all'importazione dalla Cina",
      tagDescription:
        "Scopri come importare prodotti dalla Cina con Rakumart. Segui la nostra guida passo dopo passo per ordini, pagamenti e spedizioni.",
      buDaiRakumart: true,
    },
    component: () => import("../views/footList/userGuide.vue"),
  },
  // 帮助中心首页
  {
    path: "/FAQ",
    name: "centro-de-ayuda",
    meta: {
      tagTitle: centroDeAyudaMainSeo.title,
      tagDescription: centroDeAyudaMainSeo.tagDescription,
      buDaiRakumart: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "centroDeAyudaRouterArr" */ "../views/footList/FAQ/centro-de-ayuda.vue"
      ),
  },
  // 我们的优势
  {
    path: "/ventajas",
    name: "ventajas",
    component: () => import("../views/footList/ventajas.vue"),
    meta: {},
  },
  // 问题中心答案列表页面(可以搜索到结果)
  {
    path: "/resultado-de-busqueda",
    name: "resultado-de-busqueda",
    component: () => import("../views/footList/FAQ/resultado-de-busqueda.vue"),
    meta: {},
  },
  // 问题中心答案列表页面(没有搜索到结果)
  {
    path: "/resultado-busqueda-no-encontrado",
    name: "resultado-busqueda-no-encontrado",
    component: () =>
      import("../views/footList/FAQ/resultado-busqueda-no-encontrado.vue"),
  },
  // 联系我们
  {
    path: "/Assistenza-clienti",
    name: "Atención al cliente",
    meta: {
      tagTitle: "Assistenza Clienti Rakumart - Supporto Acquisti dalla Cina",
      tagDescription:
        "Hai bisogno di aiuto? Contatta il servizio clienti Rakumart per assistenza su acquisti, fornitori e spedizioni dalla Cina. Risposte rapide e professionali.",
      buDaiRakumart: true,
    },
    component: () => import("../views/footList/Assistenza-clienti.vue"),
  },
  // 邀请注册
  {
    path: "/invitingRegistration",
    name: "invitingRegistration",
    component: () => import("../views/invitingRegistration/index.vue"),
  },
  // 调查问卷
  {
    path: "/surveyQuestionnaire",
    name: "surveyQuestionnaire",
    component: () => import("../views/surveyQuestionnaire/index.vue"),
    meta: {
      requireAuth: true,
    },
  },
  // 国际物流（写死静态路由，非接口返回）
  {
    path: "/Prezzo-della-logística",
    alias: "/Prezzo-della-logistica",
    name: "internationalLogisticsStaticPage",
    component: () =>
      import("../views/footList/Prezzo-della-logística/index.vue"),
    meta: {
      tagTitle: "Calcola i costi di spedizione dalla Cina",
      tagDescription:
        "Stima i costi di spedizione internazionale dalla Cina. Confronta le opzioni logistiche e pianifica i tuoi costi di importazione con Rakumart.",
      buDaiRakumart: true,
    },
  },
  // 用户指南
  {
    path: "/Manuale-utente",
    name: "guiaUsuario",
    meta: {
      tagTitle: "Guida all'importazione dalla Cina",
      tagDescription:
        "Scopri come importare prodotti dalla Cina con Rakumart. Segui la nostra guida passo dopo passo per ordini, pagamenti e spedizioni.",
      buDaiRakumart: true,
    },
    component: () => import("../views/footList/Manuale-utente/index.vue"),
  },
  // 摄影服务
  {
    path: "/Servizi-fotografici",
    name: "photography-service",
    meta: {
      tagTitle: "Servizio di fotografia professionale",
      tagDescription:
        "Migliora le tue vendite con foto di alta qualità. Offriamo servizi fotografici professionali per i tuoi prodotti importati dalla Cina.",
      buDaiRakumart: true,
    },
    component: () => import("../views/footList/Servizi-fotografici.vue"),
  },
];
// js获取url路由
let nowRouter =
  window.location.href.indexOf("?") == -1
    ? window.location.href.replace(window.location.origin, "")
    : window.location.href
        .replace(window.location.origin, "")
        .substr(
          0,
          window.location.href.replace(window.location.origin, "").indexOf("?")
        );
// 匹配路由是否是qa里的
let rouadd = centroDeAyuda.find((item) => {
  return nowRouter == "/" + item || nowRouter == "/" + item.router;
});
// 如果是就添加路由
if (rouadd && !routes.some((r) => r.path === "/" + (rouadd.router || rouadd))) {
  if (rouadd.router) {
    routes.push({
      path: "/" + rouadd.router,
      name: rouadd.router,
      meta: {
        tagTitle: rouadd.title,
        tagDescription: rouadd.tagDescription,
        buDaiRakumart: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "centroDeAyudaRouterArr" */ "../views/footList/FAQ/centro-de-ayuda.vue"
        ),
    });
  } else {
    routes.push({
      path: "/" + rouadd,
      name: rouadd,
      component: () =>
        import(
          /* webpackChunkName: "centroDeAyudaRouterArr" */ "../views/footList/FAQ/centro-de-ayuda.vue"
        ),
    });
  }
}

routes.push(
  getShopGroupCatchAllRoute(
    () => import("../views/CommoditySearch/index.vue"),
    false
  )
);

const router = new VueRouter({
  routes,
  mode: "history",
  base: process.env.BASE_URL || "/",
});

let categoryRoutesInitialized = false;

/** 预加载 getShopGroup 分类数据 */
export function ensureCategoryRoutes() {
  if (categoryRoutesInitialized) {
    return Promise.resolve(true);
  }
  return ensureShopGroupCategories().then((data) => {
    categoryRoutesInitialized = true;
    return !!data;
  });
}

// 写地图列表时user下的路由不要进去 /CommoditySearch /deliveryDetails /issueOrderDetail /OrderDetails /ProductDetails /shopGoods /register-success /payment /CommoditySearch /deliveryDetails /resultado-de-busqueda /cart

// // // 循环输出所有路由
// let logPath = () => {
//     let data = []
//     routes.forEach(element1 => {
//         data.push(element1.path)
//         if (element1.children && element1.children.length != 0) {
//             element1.children.forEach(element2 => {
//                 data.push(element2.path)
//             });
//         }
//     });
//     return data
// }
// let pcddd = logPath()
// console.log([...pcddd, ...centroDeAyuda]);

let urlOrigin = location.origin;
let openLogin = function(to) {
  store.commit("getactivePage", to.fullPath);
  store.commit("getshowLoginDialog", true);
};

router.beforeEach((to, from, next) => {
  // 路径 Unicode 归一化：带重音 URL 与路由表 NFC 不一致时会落入分类 catch-all 并被重定向首页
  const normalizedPath = (to.path || "/").normalize("NFC");
  if (normalizedPath !== to.path) {
    next({
      path: normalizedPath,
      query: to.query,
      hash: to.hash,
      replace: true,
    });
    return;
  }

  ensureCategoryRoutes().then(() => {
    const shopGroupRedirect = getShopGroupRouteRedirect(
      router,
      store.state.goodsList,
      to
    );
    if (shopGroupRedirect) {
      next(shopGroupRedirect);
      return;
    }

    setOnlyName(to);
    updatePageHead(to);
    if (to.query.backendPersonnel) {
      // 后台跳转前台页面操作
      sessionStorage.setItem("backendPersonnel", to.query.backendPersonnel);
      localStorage.setItem(
        "backgroundOperationID",
        to.query.backgroundOperationID
      );

      //后台直接登录客户页面使用
      localStorage.setItem("user_token", to.query.user_token);

      Vue.prototype.$api.EuropegetUserInfo().then((res) => {
        //需要登录并且已经登录了token正常的情况下跳转并更新用户信息
        store.commit("userData", res.data); // 用户信息存储
        sessionStorage.setItem("user_id", res.data.user_id);
        let query = to.query;
        delete query.backendPersonnel;
        delete query.backgroundOperationID;
        delete query.user_token;
        next({
          path: to.path,
          query: query,
        });
      });
    } else if (
      to.matched.some((record) => record.meta.requireAuth) &&
      !(["issueOrderDetail"].includes(to.name) && to.query.token)
    ) {
      // 判断该路由是否需要登录权限
      if (localStorage.getItem("user_token")) {
        //判斷是否拥有token
        Vue.prototype.$api.EuropegetUserInfo().then((res) => {
          // 登录失效
          if (res.code != 0) {
            // 需要登录并且已经登录但是token失效了就清空数据并打开登录弹窗
            store.commit("userData", null);

            localStorage.removeItem("backgroundOperationID");
            sessionStorage.removeItem("backendPersonnel");
            localStorage.removeItem("user_token");
            sessionStorage.removeItem("user_id");

            // 有需要验证的用户中心
            openLogin(to);
            next("/");
            Message.error(fanyi(res.msg));
            return;
          } else {
            //需要登录并且已经登录了token正常的情况下跳转并更新用户信息
            store.commit("userData", res.data); // 用户信息存储
            next();
          }
        });
        saveUserRequest("https://rakumart.it" + to.fullPath);
      } else {
        // 需要登录但是没有登录的情况下打开弹窗
        openLogin(to);
        next("/");
        return;
      }
    } else {
      // 不需要登录的路由直接跳转
      saveUserRequest("https://rakumart.it" + to.fullPath);
      next();
    }
    if (!to.query.backendPersonnel) {
      // 判断后台操作的id和本地的token是否一致
      if (sessionStorage.getItem("backendPersonnel")) {
        if (
          localStorage.getItem("backgroundOperationID") &&
          sessionStorage.getItem("user_id") &&
          localStorage.getItem("backgroundOperationID") !=
            sessionStorage.getItem("user_id")
        ) {
          fun.exitOperation();
        }
      }
    }
    if (localStorage.getItem("backgroundOperationID")) {
      if (!sessionStorage.getItem("backendPersonnel")) {
        MessageBox.confirm(
          "当前浏览器有操作客户账号,点击确定退出所有账号,点击取消关闭此页面",
          "提示",
          {
            confirmButtonText: "退出登录",
            cancelButtonText: "取消",
            cancel: () => {
              console.log("quxiao");
              window.close();
            },
          }
        )
          .then(() => {
            localStorage.removeItem("user_token");
            localStorage.removeItem("backgroundOperationID");
            location.reload();
          })
          .catch(() => {
            window.close();
          });
      }
    }
  });
});
// 获取商品名字
let productDetails = (to) => {
  console.log(to);
  apis
    .goodsParticulars({
      goods_id: to.query.goods_id,
      shop_type: 1688,
    })
    .then((res) => {
      if (res.code != 0 || !res.data.goodsInfo) return;
      document.title = "Rakumart-" + res.data.title.substr(0, 50);
    });
};
// 设置页面标识符,因为谷歌在爬取商品详情页面时爬取不到接口返回数据,所以需要加一个唯一的页面标示符以区分页面,否则会提示重定向
function setOnlyName(to) {
  document.getElementsByName("onlyName")[0].innerText = to.fullPath;
}
// 记录用户访问页面次数
function saveUserRequest(url) {
  apis
    .saveUserRequest({
      url: url,
    })
    .then((res) => {
      ////console.log('事件名',res)
      //if(res.data.code !=0) return this.$message.error(res.data.message)
      //接下来的操作
    });
}

// 根据路由解析页面 title、description 与 canonical
// resolveRouteHead - 解析路由头部 SEO
function resolveRouteHead(to) {
  // 商品详情页使用固定 SEO，不再用接口返回的商品标题覆盖
  if (to.name == "ProductDetails") {
    return {
      title: to.meta.tagTitle,
      description: to.meta.tagDescription || "",
      canonical: "https://www.rakumart.it" + to.fullPath,
    };
  }

  const shopGroupSeo = getShopGroupCategoryPageSeo(to);
  if (shopGroupSeo) {
    return {
      title: shopGroupSeo.tagTitle,
      description: shopGroupSeo.tagDescription || "",
      canonical: "https://www.rakumart.it" + to.fullPath,
    };
  }

  if (to.name == "CommoditySearch") {
    const title =
      to.query.keyword || to.meta.shopGroupCategory
        ? "Resultados de la búsqueda"
        : "Resultados de búsqueda de imágenes";
    return {
      title,
      description: "",
      canonical: "https://www.rakumart.it" + to.fullPath,
    };
  }

  let title = "";
  if (to.meta.buDaiRakumart) {
    title = to.meta.tagTitle;
  } else if (to.meta.tagTitle) {
    title = "Rakumart - " + to.meta.tagTitle;
  } else if (to.name == "shopGoods") {
    title = "Rakumart - " + to.query.shopName;
  } else {
    title = "Rakumart - " + to.name;
  }

  const description = to.meta.tagDescription || "";

  return {
    title,
    description,
    canonical: "https://www.rakumart.it" + to.fullPath,
  };
}

// 通过 Unhead 与 store 同步更新页面 head
// updatePageHead - 更新页面头部 SEO
function updatePageHead(to) {
  const resolved = resolveRouteHead(to);
  if (!resolved) return;

  store.commit("changeTagTitle", resolved.title);
  store.commit("changeTagDescription", resolved.description);
  applyPageHead({ canonical: resolved.canonical });
}
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
export default router;
